module.exports = __webpack_public_path__ + "img/toQrCode.5719ab65.png";